<template lang="pug">
    .room-row(v-if="room.no_of_rooms > 0")
        input(type="checkbox" :id="labelId" name="rooms" @change="pickedRoom")
        label(:for="labelId")
            .column.thumb-column
                .room-thumb( :style="{ backgroundImage: `url(${room.feature_image.path})` }" @click="clickedRoom")
                .room-details
                    h4 {{ room.room_type }} 
                    p {{ room.no_of_rooms }} bed{{ room.no_of_rooms | isPlural }} available
                    a(href="" @click.prevent="clickedRoom") More details

            .multiple-column
                .column
                    .spinner-group
                        p Number of beds

                        NumberSpinner(
                            :value="defaultValue"
                            :min="roomCounts.min"
                            :max="roomCounts.max"
                            v-model="selectedRoomSpinner"
                            ref="checkedRoomSpinner"
                        )

                    .spinner-group
                        p Bed only ({{ currency }} {{ onlyRoomFee }})

                        NumberSpinner(
                            :value="defaultValue"
                            :min="min"
                            :max="roomOnlySpinner.max"
                            v-model="roomOnlySpinner.val"
                        )

                    .spinner-group
                        p BB ({{ currency }} {{ bbRoomFee }})

                        NumberSpinner(
                            :value="defaultValue"
                            :min="min"
                            :max="bbSpinner.max"
                            v-model="bbSpinner.val"
                        )                                        
                .column
                    .spinner-group
                        p HB ({{ currency }} {{ hbRoomFee }})

                        NumberSpinner(
                            :value="defaultValue"
                            :min="min"
                            :max="hbSpinner.max"
                            v-model="hbSpinner.val"
                        )

                    .spinner-group
                        p FB ({{ currency }} {{ fbRoomFee }})

                        NumberSpinner(
                            :value="defaultValue"
                            :min="min"
                            :max="fbSpinner.max"
                            v-model="fbSpinner.val"
                        )                                                   

</template>

<script>
    import Vue from 'vue';
    import { mapGetters, mapActions } from 'vuex';    
    import NumberSpinner from './../NumberSpinner'
    import _ from 'lodash'
    import moment from 'moment';    

    export default {
        name: "Room",
        data() {
            return {
                defaultValue: 0,
                min: 0,
                max: 10,
                roomCounts: {
                    min: 0,
                    max: 10
                },
                newMaxValue: 0,
                selectedRoomSpinner: 0,
                roomOnlySpinner: {
                    val: 0,
                    max: 0
                },
                bbSpinner: {
                    val: 0,
                    max: 0
                },
                hbSpinner: {
                    val: 0,
                    max: 0
                },
                fbSpinner: {
                    val: 0,
                    max: 0
                },
                shareTotalCount: 0,
                labelId: null,
                bookingsData: {},
                pendingData: {},
                bookedRooms: 0,
                pendingRoomsCount: 0,
                equalTotal: false,
                status: 'pending',
                currency: 'USD',
                onlyRoomFee: 0,
                bbRoomFee: 0,
                hbRoomFee: 0,
                fbRoomFee: 0
            }
        },
        components: {
            NumberSpinner
        },
        computed: mapGetters(['selectedRoom', 'getCurrency', 'currencyDetails']),
        props: ['room', 'startDate', 'endDate'],
        methods: {
            ...mapActions(['fetchRoom', 'getRates']),
            showPopup() {
                this.fetchRoom(this.room.id).then(() => {
                    this.$refs.roomSliderPopup.toggle();
                });
            },
            clickedRoom() {
                this.$emit('clickedRoom', {
                    'room_id' : this.room.id
                });                
            },            
            bookings() {
                this.bookingsData = this.room;
                //this.pendingData = this.pendingRooms;

                if(this.room) {
                    //check if booking available
                    // if(this.bookingsData.length > 0) {

                    //     this.bookingsData.forEach(element => {
                    //         if (this.isRangeBetween(element.start_booked_date, element.end_booked_date)) {
                    //             this.bookedRooms += element.number_of_rooms;
                    //         }
                    //     });
                    // }
                    //check if unconfirmed bookings available
                    // if(this.pendingData.length > 0) {
                    //     this.pendingData.forEach(element => {
                    //         if(element.id == this.room.id) {
                    //             if(element.bookings.length > 0) {
                    //                 element.bookings.forEach(bookingElement => {
                    //                     if(bookingElement.booking.status == this.status) {
                    //                         if (this.isRangeBetween(bookingElement.start_booked_date, bookingElement.end_booked_date)) {
                    //                             this.pendingRoomsCount += bookingElement.number_of_rooms;
                    //                         }                                            
                    //                     }
                    //                 });
                    //             }
                    //         }
                    //     });
                    // }

                    // this.roomCounts.max = this.room.no_of_rooms - this.bookedRooms - this.pendingRoomsCount;
                    // this.shareTotalCount = this.roomCounts.max;
                    this.roomCounts.max = parseInt(this.room.no_of_rooms);
                    this.shareTotalCount = parseInt(this.room.no_of_rooms);                    

                }

            },
            isRangeBetween(start_booked_date, end_booked_date) {
                var compare_start_booked_date = moment(start_booked_date, "YYYY-MM-DD");
                var compare_end_booked_date = moment(end_booked_date, "YYYY-MM-DD");

                var start_date   = moment(this.startDate, "YYYY-MM-DD");
                var end_date     = moment(this.endDate, "YYYY-MM-DD");

                var booked_rooms;

                if(compare_start_booked_date.isSameOrBefore(end_date) && compare_end_booked_date.isSameOrAfter(start_date)) {
                    return true;
                } else {
                    return false;
                }
            },
            pickedRoom(event) {
                if(event.target.checked) {
                    this.$emit('pickedRoom', [{
                        'checked': true,
                        'validate': this.equalTotal,
                        'room_id' : this.room.id,
                        'number_of_rooms': this.selectedRoomSpinner,
                        'only_room': this.roomOnlySpinner.val,
                        'number_of_bb': this.bbSpinner.val,
                        'number_of_hb': this.hbSpinner.val,
                        'number_of_fb': this.fbSpinner.val,
                        'total_only_room_cost': parseInt(this.roomOnlySpinner.val) * this.room.price_per_day_room,
                        'total_bb_cost': parseInt(this.bbSpinner.val) * this.room.price_per_day_bb,                                       'total_hb_cost': parseInt(this.hbSpinner.val) * this.room.price_per_day_hb,
                        'total_fb_cost': parseInt(this.fbSpinner.val) * this.room.price_per_day_fb
                    }]);
                } else {
                    this.$emit('pickedRoom', [{
                        'checked': false,
                        'room_id' : this.room.id
                    }]);                    
                }
            },
            pickedRoomData() {
                this.$emit('pickedRoomData', [{
                    'room_id' : this.room.id,
                    'validate': this.equalTotal,
                    'number_of_rooms': this.selectedRoomSpinner,
                    'only_room': this.roomOnlySpinner.val,
                    'number_of_bb': this.bbSpinner.val,
                    'number_of_hb': this.hbSpinner.val,
                    'number_of_fb': this.fbSpinner.val,
                    'total_only_room_cost': parseInt(this.roomOnlySpinner.val) * this.room.price_per_day_room,
                    'total_bb_cost': parseInt(this.bbSpinner.val) * this.room.price_per_day_bb,                                       'total_hb_cost': parseInt(this.hbSpinner.val) * this.room.price_per_day_hb,
                    'total_fb_cost': parseInt(this.fbSpinner.val) * this.room.price_per_day_fb                    
                }]);                
            },
            setValue(type, value) {
                switch(type) {
                    case 'room':
                        this.roomOnlySpinner.val = value;
                    break;

                    case 'bb':
                        this.bbSpinner.val = value;
                    break;

                    case 'hb':
                        this.hbSpinner.val = value;
                    break;

                    case 'fb':
                        this.fbSpinner.val = value;
                    break;
                }
            },
            setMax() {
                this.roomOnlySpinner.max = this.selectedRoomSpinner;

                // identify the max value to room only spinner
                var max_value = this.selectedRoomSpinner - this.roomOnlySpinner.val;

                // setting the max value to other spinners
                this.bbSpinner.max = max_value;
                this.hbSpinner.max = max_value;
                this.fbSpinner.max = max_value;

                var equal_total = 0;
                
                if(this.roomOnlySpinner.val !== 0) {
                    equal_total += this.bbSpinner.val + this.hbSpinner.val + this.fbSpinner.val;
                } else {
                    equal_total += this.roomOnlySpinner.val + this.bbSpinner.val + this.hbSpinner.val + this.fbSpinner.val;
                }

                if(equal_total == max_value) {

                    this.roomOnlySpinner.max = this.roomOnlySpinner.val
                    this.bbSpinner.max = this.bbSpinner.val;
                    this.hbSpinner.max = this.hbSpinner.val;
                    this.fbSpinner.max = this.fbSpinner.val;

                    this.equalTotal = true;
                }

                if(equal_total < max_value) {
                    var diff = max_value - equal_total;

                    this.roomOnlySpinner.max = this.roomOnlySpinner.val + diff;
                    this.bbSpinner.max = this.bbSpinner.val + diff;
                    this.hbSpinner.max = this.hbSpinner.val + diff;
                    this.fbSpinner.max = this.fbSpinner.val + diff;

                    this.equalTotal = false;
                }

            },
            ...Vue.filter('isPlural', function(value) {
                if(value) {
                    return (value > 1) ? 's' : '';
                }
            }),
            updateFee() {
                this.currency = 'USD';
                this.onlyRoomFee = this.room.price_per_day_room;
                this.bbRoomFee = this.room.price_per_day_bb;
                this.hbRoomFee = this.room.price_per_day_hb;
                this.fbRoomFee = this.room.price_per_day_fb;
            },
            onCurrencyUpdate() {
                if(this.getCurrency == 'LKR') {
                    this.getRates().then(() => {

                        this.currency = this.getCurrency;

                        this.onlyRoomFee = this.room.price_per_day_room * this.currencyDetails.lkr;
                        this.bbRoomFee = this.room.price_per_day_bb * this.currencyDetails.lkr;
                        this.hbRoomFee = this.room.price_per_day_hb * this.currencyDetails.lkr;
                        this.fbRoomFee = this.room.price_per_day_fb * this.currencyDetails.lkr;                        
                    });
                } else {
                   this.updateFee() 
                }
            }                                   
        },
        mounted() {
            this.labelId = _.uniqueId();
            this.bookings();
            this.$watch('roomOnlySpinner.val', () => {
                this.pickedRoomData();
            });
            this.$watch('bbSpinner.val', () => {
                this.pickedRoomData();
            })
            this.$watch('hbSpinner.val', () => {
                this.pickedRoomData();
            })
            this.$watch('fbSpinner.val', () => {
                this.pickedRoomData();
            }),
            this.onCurrencyUpdate();                                  
        },
        watch: {
            selectedRoomSpinner: {
                handler: function() {
                    this.setMax();
                },
                deep: true
            },
            'roomOnlySpinner.val': {
                handler: function(val) {
                    this.setValue('room', val);
                    this.setMax();
                },
                deep: true
            },
            'bbSpinner.val': {
                handler: function(val) {
                    this.setValue('bb', val);
                    this.setMax();                   
                },
                deep: true
            },
            'hbSpinner.val': {
                handler: function(val) {
                    this.setValue('hb', val);
                    this.setMax();                     
                },
                deep: true
            },
            'fbSpinner.val': {
                handler: function(val) {
                    this.setValue('fb', val);
                    this.setMax();                     
                },
                deep: true
            },
            getCurrency: {
                handler: function() {
                    this.onCurrencyUpdate();
                }
            }            
        }
    };
</script>

<style lang="sass">
    @import "@/assets/css/2-base/_variables.sass"
    @import "@/assets/css/2-base/_placeholder.sass"
    @import "@/assets/css/3-components/_rooms.sass"    
</style>

